import { FC, useState } from 'react'
import PageLayout from '../../components/page-layout/page-layout'
import { useGetMachinesQuery } from '../../store/api/machines-api'
import Machine from '../../types/api/machine'
import MachinePicker from '../machines-schedule/components/machine-picker/machine-picker'
import { rewinderMachinesQuery } from '../schedules/rewind/constants/query-params'
import HelpDrawer from './components/help-drawer/help-drawer'
import OneRewinderMachineSchedule from './components/one-rewinder-machine/one-rewinder-machine'

interface RewinderMachinesSchedulePageProps {}

const RewinderMachinesSchedulePage: FC<RewinderMachinesSchedulePageProps> = () => {
    const [currentMachine, setCurrentMachine] = useState<Machine>()
    const { data } = useGetMachinesQuery(rewinderMachinesQuery)
    const machines = [...(data?.data || [])].sort((a, b) => a.name.localeCompare(b.name))

    return (
        <PageLayout
            title={`Перемотка ${currentMachine?.name || ''}`}
            scrollableContent
            beforeUser={<HelpDrawer />}
        >
            {currentMachine ? (
                <OneRewinderMachineSchedule machine={currentMachine} />
            ) : (
                <MachinePicker
                    machines={machines}
                    onSelect={setCurrentMachine}
                    title='Выберите станок перемотки'
                />
            )}
        </PageLayout>
    )
}

export default RewinderMachinesSchedulePage
